import { createSvgComponent } from "../../icon/createSvgComponent";
import Review from "@core/icon/assets/review.svg";
export default createSvgComponent(Review);